import React from 'react'
import Button from 'material-ui/Button'
import { withStyles } from 'material-ui/styles'
import styles from './styles'

import SearchBar from '../common/search'
import Table from '../table'
import Title from '../ui/title'
import Content from '../ui/content'
import Context from './context/'
import Toolbar from './toolbar/'
import NewDeviceSoftwareRelease from './new/';
import withRole from '../hoc/role'
import ConfirmDialog from '../common/dialog/confirm'

import {
  ROLES_IDEAL_ADMIN
} from '../../common/constants'

class DeviceSoftwareReleases extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      modal: null,
      mode: null,
      contextMenu: false,
      showConfirmDelete: false,
      currentRow: null,
      selected: {},
      filterable: false
    };

    this.toggle = this.toggle.bind(this);
    this.toggleColumns = this.toggleColumns.bind(this);
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.add = this.add.bind(this);
    this.edit = this.edit.bind(this);
    this.del = this.del.bind(this);
    this.showConfirmDel = this.showConfirmDel.bind(this);
    this.hideConfirmDel = this.hideConfirmDel.bind(this);
  }

  componentWillMount() {
    const { softwares, pager, translate } = this.props;
    const { defaultColumns } = pager;
    const { filterable } = this.state;
    let columns = [];
    
    console.log(softwares);

    softwares.columns.forEach((column, index) => {
      columns.push({
        id: column.field,
        Header: translate(column.field),
        accessor: d => d[column.field],
        show: defaultColumns.includes(column.field),
        toggle: true,
        display: column.display,
        filterable
      })
  });

    this.setState({
      columns: columns
    });
  }

  toggle() {
    this.setState({
      contextMenu: !this.state.contextMenu
    })
  }

  toggleColumns(column) {
    let columns = [...this.state.columns]
    columns.forEach((c) => {
      if (c.id === column.id) {
        c.show = column.show
      }
    })
    this.setState({
      columns: columns
    })
  }

  toggleFilters = () => {
    let columns = [...this.state.columns]
    let { filterable } = this.state
    columns.forEach((c) => {
      c.filterable = !filterable
    })
    this.setState({
      columns: columns,
      filterable: !filterable
    })
  }

  add() {
    this.showModal('create')
  }

  edit(row) {
    this.props.get(row);
    this.showModal('edit')
  }

  showModal(mode) {
    this.setState({
      modal: true,
      mode
    })
  }

  closeModal(reset) {
    reset && this.props.reset()
    this.setState({
      modal: false
    })
  }

  showConfirmDel(row) {
    const { softwares } = this.props
    let data = softwares.data ? softwares.data.find(x => x.id === parseInt(row, 10)) : null
    this.setState({
      currentRow: { ...data },
      showConfirmDelete: true
    })
  }

  hideConfirmDel() {
    this.setState({
      currentRow: null,
      showConfirmDelete: false
    })
  }

  del() {
    this.props.del(this.state.currentRow.id, this.props.pager).then( response  => {
    this.setState({
      selected : {}
    })
  })
    this.hideConfirmDel();
  }

  selectedRows = (rows) => {
    this.setState({
      selected: rows
    });
  }

  removedSelectedRadioCheck = () => {
    this.setState({
      selected: {}
    })
  }

  render() {
    const {
      translate,
      languages,
      create,
      softwareId,
      software,
      softwares,
      pager,
      update,
      fetch,
      search,
      reset,
      deviceTypes,
      allRepositories,
      minimumVersions
    } = this.props

    const {
      selected,
      filterable
    } = this.state

    const _selected = { ...selected }

    let $modal = this.state.modal ? (
      <NewDeviceSoftwareRelease
        languages={languages}
        mode={this.state.mode}
        modal={this.state.modal}
        close={this.closeModal}
        create={create}
        update={update}
        pager={pager}
        translate={translate}
        software={software}
        deviceTypes={deviceTypes}
        allRepositories={allRepositories}
        minimumVersions={minimumVersions}
        removedSelectedRadioCheck={this.removedSelectedRadioCheck}
        reset={ reset }
      />
    ) : (null)

    let $context = (
      <Context
        toggleColumns={this.toggleColumns}
        data={softwares.data}
        columns={this.state.columns}
        translate={translate}
      />
    )

    let confirmText = 'Are you sure you want to delete device software release';
    
    let selectedRecords = Object.keys(selected).filter(x => selected[x])
    
    return (
      <div style={{marginTop: "135px"}}>
        <Title
          title={'Device Software Releases'}
          toolbar={<Toolbar
            translate={translate}
            toggle={() => this.toggle()}
            add={() => this.add()}
            edit={() => this.edit(selectedRecords[0])}
            remove={() => this.showConfirmDel(selectedRecords[0])}
            selectedRecords={selectedRecords}
            toggleFilters={this.toggleFilters}
          />}
        />
        <Content ctx={$context} open={this.state.contextMenu} toggle={() => this.toggle()} translate={translate}>
          {filterable ? (<SearchBar search={search} pager={pager} translate={translate} />) : null}
          <Table
            translate={translate}
            filterable={true}
            minRows={0}
            pages={softwares.pagecount}
            manual={pager.manual}
            defaultPageSize={pager.pagesize}
            data={softwares.data}
            columns={this.state.columns}
            fetch={fetch}
            allowSelectOne
            selectedRows={this.selectedRows}
            selected={_selected}
            pager={pager}
            style={{
              border: 'none',
            }}

          />
          {$modal}
          <ConfirmDialog
            open={this.state.showConfirmDelete}
            title={'Delete Device Software Release'}
            contentText={confirmText}
            contentSecondaryText={translate('general_confirmation_help_2')}
            okText={translate('general_confirm')}
            cancelText={translate('general_cancel')}
            onOk={this.del}
            onCancel={this.hideConfirmDel}
          />
        </Content>
      </div>
    )
  }
}

export default withStyles(styles)(DeviceSoftwareReleases)
